import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-healthcare-custom-brand',
  imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './healthcare-custom-brand.html',
  styleUrl: './healthcare-custom-brand.scss',
})
export class HealthcareCustomBrand {

}
